export const THRESHOLD_QR_RECREATION_MARGIN_DURATION_IN_MINS = 10;
